/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ suffix: NonNullable<unknown> }} Explorer_Table_Move_Locked_ErrorInputs */



/**
* | output |
* | --- |
* | "Cannot move locked item{suffix}" |
*
* @param {Explorer_Table_Move_Locked_ErrorInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_table_move_locked_error = /** @type {((inputs: Explorer_Table_Move_Locked_ErrorInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Table_Move_Locked_ErrorInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Impossible de deplacer l'element verrouille${i?.suffix}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Gesperrtes Objekt${i?.suffix} kann nicht verschoben werden`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Impossibile spostare l'oggetto bloccato${i?.suffix}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Невозможно переместить заблокированный элемент${i?.suffix}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`No se puede mover el elemento bloqueado${i?.suffix}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`无法移动锁定物品${i?.suffix}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`ロックされたアイテムを移動できません${i?.suffix}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`लॉक किए गए आइटम${i?.suffix} को स्थानांतरित नहीं किया जा सकता`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Não é possível mover o item bloqueado${i?.suffix}`)
	return /** @type {LocalizedString} */ (`Cannot move locked item${i?.suffix}`)
});